import { borderRadius, borderWidth } from './border';
import appUrl from './getAppUrl';
import env from './getEnv';
import gradients from './gradients';
import isBrowser from './isBrowser';
import isNode from './isNode';
import isReactNative from './isReactNative';
import routes from './routes';
import shadows from './shadows';
import spacing from './spacing';
import { fontWeight } from './typography';
import * as whitelabels from './whitelabels';
import { config } from 'client-config';

if (env !== 'test')
  console.log(
    `[config] Using APP_ENV="${env}" appUrl="${appUrl}" aws_region="${config.aws_region}" redirect_service="${process.env.USE_AUTH0_REDIRECT_SERVICE}"`
  );

const region: keyof typeof config.s3 =
  (config?.aws_region as keyof typeof config.s3) ?? 'us-east-2';

const s3Region: Record<string, any> = config?.s3?.[region] ?? {};

const AmazonS3Buckets = {
  Lane: s3Region?.mediaBucket,
  Activate: s3Region?.privateMediaBucket ?? s3Region?.mediaBucket,
  EssensysReports: s3Region?.essensysReports,
  IntegrationGateway: s3Region?.integrationsGateway,
  VisitorManagementAppleWalletPasses:
    s3Region?.visitorManagementAppleWalletPasses,
} as const;

export {
  config,
  appUrl,
  gradients,
  shadows,
  routes,
  whitelabels,
  env,
  isReactNative,
  isNode,
  isBrowser,
  spacing,
  borderWidth,
  borderRadius,
  fontWeight,
  AmazonS3Buckets,
};

export default {
  ...config,
  gradients,
  shadows,
  routes,
  whitelabels,
  env,
  isReactNative,
  isNode,
  isBrowser,
};
